module.exports = __webpack_public_path__ + "img/vie_button.a0304407.png";